import {DateTime} from 'luxon';
import {Text, View} from 'native-base';
import React from 'react';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

import {StyledPressable} from 'components/Styled';
import useHover from 'hooks/useHover';
import {ReservationDate} from 'models/Reservations';
import {useTheme} from 'styled-components/native';

interface ReservationListItemProps {
  reservation: ReservationDate;
  selected?: boolean;
  onPress?: () => any;
}

const ReservationListItem: React.FC<ReservationListItemProps> = props => {
  const {reservation, selected = false, onPress} = props;
  const {hovering, handleHoverIn, handleHoverOut} = useHover();
  const theme = useTheme();
  const {ghostWhite, transparent, caesarRewards, tuna} = theme.colors;

  return (
    <StyledPressable
      paddingY={3}
      paddingX={4}
      marginBottom={3}
      borderRadius="8px"
      flexDirection="row"
      onPress={onPress}
      onHoverIn={handleHoverIn}
      onHoverOut={handleHoverOut}
      backgroundColor={hovering || selected ? ghostWhite : transparent}>
      <Icon
        name={selected ? 'calendar-check' : 'calendar'}
        light={!selected}
        solid={selected}
        color={selected ? caesarRewards : tuna}
        size={theme.fontSizes[3]}
      />
      <View paddingX={2} flex={1}>
        <Text fontSize={3} color={tuna} fontWeight={selected ? 700 : 400}>
          {DateTime.fromFormat(reservation.checkInDate, 'MM-dd-yyyy')
            .toFormat('MMM dd, yyyy')
            .toUpperCase()}
          {' - '}
          {DateTime.fromFormat(reservation.checkOutDate, 'MM-dd-yyyy')
            .toFormat('MMM dd, yyyy')
            .toUpperCase()}
        </Text>
        <Text paddingTop={1} fontSize={2} color={tuna} opacity={0.7}>
          {reservation.propertyName}
        </Text>
      </View>
    </StyledPressable>
  );
};

export default ReservationListItem;
